// https://next.chakra-ui.com/docs/theming/customize-theme
// https://github.com/chakra-ui/chakra-ui/tree/master/packages/theme/src
import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react'

import * as components from './components'
import * as foundations from './foundations'

export const theme = extendTheme(
  {
    // NOTE: es module will break theme, need spreading to plan object
    // Component style overrides
    components: { ...components },

    // Foundational style overrides
    ...foundations,

    styles: {
      global: (props) => ({
        '[data-toast-inner]': { minWidth: 'auto !important' },
      }),
    },
  },
  withDefaultColorScheme({ colorScheme: 'brand' }),
)
